import { gql } from 'apollo-angular';
import { IssueType } from '../../entities/issue/issue-type';

export interface IssueTypeFilter {
  code?: string;
  isActive?: boolean;
}

export const GET_ISSUETYPES_QUERY = gql`
  query getIssueTypes($filter: IssueTypeFilter) {
    getIssueTypes(filter: $filter) {
      code
      name
    }
  }
`;

export interface GetIssueTypesResponse {
  getIssueTypes: IssueType[];
  loading: boolean;
}
